import React from 'react';
import { SanityBlock } from '@repo/models/gatsby-graphql-types';
import BlockBuilder from '@repo/ui-components/sanity/BlockBuilder';

interface TwoColumnLayoutProps {
  value: {
    heading?: string;
    primaryColumn?: {
      blocks?: SanityBlock[];
    };
    secondaryColumn?: {
      blocks?: SanityBlock[];
    };
    primaryColumnVerticalAlignment?: 'Top' | 'Center' | 'Bottom';
    secondaryColumnVerticalAlignment?: 'Top' | 'Center' | 'Bottom';
    primaryColumnBorder?: boolean;
    secondaryColumnBorder?: boolean;
  };
  getInternalLink: (string) => string;
}

function BlockBuilderTwoColumnLayout({
  value,
  getInternalLink,
}: Readonly<TwoColumnLayoutProps>) {
  const {
    heading,
    primaryColumn,
    secondaryColumn,
    primaryColumnVerticalAlignment,
    secondaryColumnVerticalAlignment,
    primaryColumnBorder,
    secondaryColumnBorder,
  } = value;

  const getAlignmentClass = (align?: string) => {
    switch (align) {
      case 'Top':
        return 'self-start';
      case 'Center':
        return 'self-center';
      case 'Bottom':
        return 'self-end';
      default:
        return '';
    }
  };

  const getColumnClasses = (border?: boolean, align?: string) =>
    [
      'flex flex-col items-start box-border w-full',
      border ? 'p-4 border' : '',
      getAlignmentClass(align),
    ]
      .filter(Boolean)
      .join(' ');

  return (
    <div
      style={{
        marginBlock: '2rem',
      }}
    >
      {heading && <h2>{heading}</h2>}
      <div className="flex flex-col gap-4 md:flex-row md:gap-8 [&_ul]:ps-5 [&_.dynamic-dealer-pricing]:mx-0">
        {primaryColumn?.blocks?.length > 0 && (
          <div
            className={getColumnClasses(
              primaryColumnBorder,
              primaryColumnVerticalAlignment
            )}
          >
            <BlockBuilder
              blocks={primaryColumn.blocks}
              getInternalLink={getInternalLink}
            />
          </div>
        )}
        {secondaryColumn?.blocks?.length > 0 && (
          <div
            className={getColumnClasses(
              secondaryColumnBorder,
              secondaryColumnVerticalAlignment
            )}
          >
            <BlockBuilder
              blocks={secondaryColumn.blocks}
              getInternalLink={getInternalLink}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default BlockBuilderTwoColumnLayout;
